import BasePropertyTabView from 'properties/BasePropertyTabView';
import propertyViewMapService from 'PropertyViewMapService.js';
import contentTemplate from 'behaviors/properties/tab-settings-view.ejs';

class TabSettingsView extends BasePropertyTabView {

    initialize( opts ) {
        this.options = opts || {};

        this.tagName = 'div';
        this.id = '#settings';
        this.factoryKey = opts.factoryKey;
        this.template = contentTemplate; 

        super.initialize(opts);

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        return this;
    } 

    render() {
        this.factoryKey = this.model.attributes.factoryKey;
        super.render();

        // Render Property Views
        var views = [];

        if (this.options.type === 'workflow' || this.options.type === 'workflow_stage' || this.options.type === 'workflow_comment') {
            views = propertyViewMapService.getWorkflowSettingsViews(this.factoryKey);
        } else {
            views = propertyViewMapService.getBehaviorSettingsViews(this.factoryKey);
        }

        this.renderPropertyViews(views, this.model);

        return this;
    }
}

export default TabSettingsView;